export default "__VITE_ASSET__DgHSmieG__"